import StylesSnackbarServiceInterface
  from '~/src/components/mui-wrappers/styled/snackbar/styles/StylesSnackbarServiceInterface'
import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'

export default class StylesSnackbarServiceStyleTwo extends TemplateServiceStyleBase implements StylesSnackbarServiceInterface {
  public getComponentSx(): Record<string, unknown> {
    return {}
  }
}
